import Classdetails from "./Class-details";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React, { useState } from "react";
import StudentTable from "./studenttable";
import UserDetails from "./UserPanel";
import axios from "axios";
import classnames from "classnames";
import { siLK } from "@mui/material/locale";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getoveralldata } from "../../store/classroom/actions";

import {
  Button,
  Card,
  CardBody,
  CardText,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from 'reactstrap';

const Inbox = () => {
  document.title = 'Linc Quality Hub';
  const [loading, setLoading] = useState(true); // New loading state
  const [studentDeatils, setStudentDeatils] = useState([]);
  const [tabledata, setTableData] = useState([]);
  const [noofFlags, setNoofFlags] = useState(null);
  const [conversationDetails, setConversationDetails] = useState({});

  // // console.log("data",noofFlags)
  const [cardDataTranscription, setCardTranscription] = useState([]);
  const [setStudentInsights, setStudentCallInsights] = useState({});
  const [loading1, setLoading1] = useState(true);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [selectedEmailReceived, setSelectedEmailReceived] = useState(null);
  const [selectedsuccessfulcalls, setSelectedsuccessfulcalls] = useState(null);
  const [seletedItem, setseletedItem] = useState(null);
  const [selectedUnsuccessfulcalls, setSelectedUnsuccessfulcalls] = useState(
    {},
  );
  const [selectedIncomingsms, setselectedIncomingsms] = useState(null);
  const [selectedsmssent, setselectedsmssent] = useState(null);
  const [selectedVideoCall, setSelectedVideoCall] = useState(null);
  const [isVideoCallModalOpen, setIsVideoCallModalOpen] = useState(false);
  const [selectedUnsuccessfulVideoCall, setSelectedUnsuccessfulVideoCall] =
    useState(null);
  const [modal_video_unsuccess, setModalVideoUnsuccess] = useState(false); // Unsuccessful Video Call

  const [Schedulemodal_center, setSchedulemodal_center] = useState(false);
  const user_token = localStorage.getItem('usertoken');


  // console.log('dataunsuccessful', selectedUnsuccessfulcalls);

  // const [customActiveTab, setcustomActiveTab] = useState("1");
  const navigate = useNavigate(); // Initialize navigate
  const handleNavtoTransactions = () => {
    // navigate('/individualteacher', { state: Deatilsofteacher });
    navigate(-1);
  };
  const location = useLocation();
  const StudentName = location.state?.StudentName;
  const studetails = location.state;
  const Deatilsofteacher = location.state;
  console.log('inv stu', studetails);
  //tab
  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('all');

  // Function to handle tab change
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };
  // modal
  const [modal_center, setmodal_center] = useState(false);
  function tog_center() {
    setmodal_center(!modal_center);
  }

  const [modal_center1, setmodal_center1] = useState(false);
  function tog_center1() {
    setmodal_center1(!modal_center1);
  }
  const toggleVideoCallModal = () => {
    setIsVideoCallModalOpen(!isVideoCallModalOpen);
  };

  const [modal_center2, setmodal_center2] = useState(false);
  function tog_center2() {
    setmodal_center2(!modal_center1);
  }
  const [modal_centerv, setmodal_centerv] = useState(false);
  function tog_centerv() {
    setmodal_centerv(!modal_centerv); // Correcting the toggle state
  }

  const [modal_center3, setmodal_center3] = useState(false);
  function tog_center3() {
    setmodal_center3(!modal_center1);
  }

  const [modal_center4, setmodal_center4] = useState(false);
  function tog_center4() {
    setmodal_center4(!modal_center1);
  }

  const [modal_center5, setmodal_center5] = useState(false);
  function tog_center5() {
    setmodal_center5(!modal_center1);
  }

  // tabs

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const iconMap = {
    'SMS': 'sms-icon',
    'Schedule Call': 'schedule-call-icon',
    'Reminder Call': 'reminder-call-icon',
    'Video Call': 'video-call-icon', // Add more types as needed
    'Audio Call': 'call-icon',
    'Schedule Chat': 'schedule-chat-icon',
    // Default icon if no match is found
  };

  // Get the icon class based on the type
  const getIconClass = (item) => {
    // Loop through the iconMap to check if the item type matches any of the keys
    for (let key in iconMap) {
      if (item.type.includes(key)) {
        return iconMap[key];
      }
    }
    return 'default-icon'; // Fallback if no match is found
  };
  const [customActiveTab, setcustomActiveTab] = useState('1');

  const [pieOptions, setPieOptions] = useState({
    chart: {
      type: 'pie',
    },
    title: {
      text: null,
    },
    series: [
      {
        name: 'No of calls',
        data: [
          {
            name: 'Not Flagged',
            y: 0, // Default value (can be dynamically updated)
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#FEE3E2'],
                [1, '#FFA1B1'],
              ],
            },
          },
          {
            name: 'Flagged',
            y: 0, // Default value (can be dynamically updated)
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#E9FEED'],
                [1, '#B8FDCA'],
              ],
            },
          },
        ],
        color: 'white',
        dataLabels: {
          enabled: true,
          format: '{point.y}% {point.name}', // Adds percentage and label (e.g., "70% Not Flagged")
          style: {
            color: 'black',
            fontWeight: 'bold',
          },
        },
      },
    ],
    tooltip: {
      pointFormat: '{point.name}: <b>{point.y}%</b>',
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
    },
  });
  // // console.log("pie",pieOptions)

  const [progressOptions, setProgressOptions] = useState({
    chart: {
      type: 'bar',
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: ['Sent', 'Received'],
    },
    yAxis: {
      title: {
        text: '',
      },
    },
    series: [
      {
        data: [
          {
            // y: 0, // Default value (can be dynamically updated)
            name: 'Sent',
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#E7EEFF'],
                [1, '#ABC5FE'],
              ],
            },
            dataLabels: {
              enabled: true,
              style: {
                color: '#000', // Customize text color
                fontSize: '12px',
                fontWeight: 'bold',
              },
            },
          },
          {
            // y: 0, // Default value (can be dynamically updated)
            name: 'Received',
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#FFE8D6'],
                [1, '#FCCD97'],
              ],
            },
            dataLabels: {
              enabled: true,
              style: {
                color: '#000', // Customize text color
                fontSize: '12px',
                fontWeight: 'bold',
              },
            },
          },
        ],
        name: 'Number of Messages',
        color: 'white',
        pointWidth: 10,
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enable: true,
      chartOptions: {
        title: {
          text: 'Total Messages Sent and Received',
        },
      },
    },
  });

  // // console.log("pie",progressOptions)

  useEffect(() => {
    const fetchDataTeacherQc = async () => {
      try {
        setLoading(true);

        const payload = {
          university:
            studetails.appliedUniversities?.size > 0
              ? Array.from(studetails.appliedUniversities)
              : null,
          program:
            studetails.appliedPrograms?.size > 0
              ? Array.from(studetails.appliedPrograms)
              : null,
          year:
            studetails.appliedTimelines?.size > 0
              ? Array.from(studetails.appliedTimelines)
              : null,
          term:
            studetails.appliedTerms?.size > 0
              ? Array.from(studetails.appliedTerms)
              : null,
          unit_id:
            studetails.appliedUnit?.size > 0
              ? Array.from(studetails.appliedUnit)
              : null,
          teacher_id:
            studetails.appliedTeacher?.size > 0
              ? parseInt(Array.from(studetails.appliedTeacher))
              : null,
          student_id: studetails.Studentid || null,
          mode: 'individual_student_report',
        };

        // console.log('Payload:', payload);
        let config = {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        };


        console.log('1. state', location.state);
        console.log('2. payload', JSON.stringify(payload));

        const response = await axios.post(
          process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
          payload,
          config
        );

        console.log('3. raw response', response);
        console.log('4. student_data?', response.student_data, 'data?', response.data);
        // console.log('API Response:', response);

        // Process response data
        const responseteach = response.student_data;
        setStudentDeatils(responseteach.cards);
        setTableData([responseteach.History] || []);
        setConversationDetails(responseteach.conversation_history || {});
        //charts
        // Extract dynamic values from the response
        const flagged = responseteach.Number_of_calls_flagged.flagged;
        const nonFlagged = responseteach.Number_of_calls_flagged.non_flagged;
        const messagesSent =
          responseteach.Total_messages_sent_and_received.messages_sent;
        const messagesReceived =
          responseteach.Total_messages_sent_and_received.messages_received;

        // Update Pie Chart Options Dynamically
        const updatedPieOptions = {
          ...pieOptions,
          series: [
            {
              name: 'No of calls',
              data: [
                {
                  name: 'Not Flagged',
                  y: (nonFlagged / (flagged + nonFlagged)) * 100, // Calculate percentage dynamically
                  color: {
                    linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
                    stops: [
                      [0, '#FEE3E2'],
                      [1, '#FFA1B1'],
                    ],
                  },
                },
                {
                  name: 'Flagged',
                  y: (flagged / (flagged + nonFlagged)) * 100, // Calculate percentage dynamically
                  color: {
                    linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
                    stops: [
                      [0, '#E9FEED'],
                      [1, '#B8FDCA'],
                    ],
                  },
                },
              ],
              color: 'white',
              dataLabels: {
                enabled: true,
                format: '{point.y}% {point.name}', // Adds percentage and label (e.g., "70% Not Flagged")
                style: {
                  color: 'black',
                  fontWeight: 'bold',
                },
              },
            },
          ],
        };

        // Update Progress Bar Options Dynamically
        const updatedProgressOptions = {
          ...progressOptions,
          series: [
            {
              data: [
                {
                  y: messagesSent, // Dynamically set number of messages sent
                  name: 'Sent',
                  color: {
                    linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
                    stops: [
                      [0, '#E7EEFF'],
                      [1, '#ABC5FE'],
                    ],
                  },
                },
                {
                  y: messagesReceived, // Dynamically set number of messages received
                  name: 'Received',
                  color: {
                    linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
                    stops: [
                      [0, '#FFE8D6'],
                      [1, '#FCCD97'],
                    ],
                  },
                  dataLabels: {
                    enabled: true, // Enable data labels
                    format: ' {point.y}', // Format the data label
                    style: {
                      color: '#000', // Text color
                      fontWeight: 'bold',
                      fontSize: '12px',
                    },
                  },
                },
              ],
              name: '',
              color: 'white',
              pointWidth: 10,
            },
          ],
        };

        // Set the updated options
        setPieOptions(updatedPieOptions);
        setProgressOptions(updatedProgressOptions);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDataTeacherQc();
  }, [studetails.appliedTeacher, studetails.Studentid]); // Add these

  useEffect(() => {
    const fetchDataTeacher = async () => {
      if (!studetails) {
        console.error('studetails is undefined or missing');
        return;
      }

      const payload = {
        university:
          studetails.appliedUniversities?.size > 0
            ? Array.from(studetails.appliedUniversities)
            : null,
        program:
          studetails.appliedPrograms?.size > 0
            ? Array.from(studetails.appliedPrograms)
            : null,
        year:
          studetails.appliedTimelines?.size > 0
            ? Array.from(studetails.appliedTimelines)
            : null,
        term:
          studetails.appliedTerms?.size > 0
            ? Array.from(studetails.appliedTerms)
            : null,
        unit_ids:
          studetails.appliedUnit?.size > 0
            ? Array.from(studetails.appliedUnit)
            : null,
        teacher_ids:
          studetails.appliedTeacher?.size > 0
            ? Array.from(studetails.appliedTeacher)
            : null,
        student_id: studetails?.Studentid || null,
      };

      // console.log('Payload:', payload); // Debug the payload
      let config = {
        headers: {
          Authorization: `Token ${user_token}`,
        },
      };
      try {
        setLoading1(true);
        const response = await axios.post(
          process.env.REACT_APP_API_BASE_URL + 'individual_student_timeline/',
          payload,
          config
        );
        console.log('API Response:', response.data); // Debug the API
        setCardTranscription(response.data);
        setStudentCallInsights(response?.data?.call_insights || {})
      } catch (error) {
        console.error(
          'Error fetching data:',
          error.response?.data || error.message,
        );
      } finally {
        setLoading1(false);
      }
    };

    fetchDataTeacher();
  }, [studetails?.appliedTeacher, studetails?.Studentid, studetails]);

  const dispatch = useDispatch();


  // Scroll to top only once, when this page loads
  useEffect(() => {
    window.scrollTo(0, 0);
    // If the page uses an inner scroll container (common in admin templates), reset it too
    const pageContent = document.querySelector('.page-content');
    if (pageContent) pageContent.scrollTop = 0;
    const mainContent = document.querySelector('.main-content');
    if (mainContent) mainContent.scrollTop = 0;
  }, []);


  const { conversationData, overallData, error } = useSelector((state) => ({
    overallData: state?.classroom?.OverallData?.overall_data || [],
    conversationData: state?.classroom?.OverallData?.conversation_data,
    error: state.classroom.error,
    loading: state.classroom.loading,
  }));

  useEffect(() => {
    dispatch(getoveralldata());
  }, [dispatch]);

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   return date && date.getTime() !== new Date('1000-01-01').getTime()
  //     ? date.toLocaleString()
  //     : 'N/A';
  // };

  const formatDate = (dateString) => {
    if (!dateString || dateString === 'N') return 'N/A'; // Handle empty or invalid values

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A'; // Handle cases where parsing fails

    return date.toLocaleString(); // Convert to readable format
  };

  // const formatText = (text) => (text && text !== 'No mails sent' && text !== 'No mails received' && text !== 'No Incoming SMS') ? text : 'N/A';
  const formatText = (text) => {
    if (!text) {
      return 'N/A'; // Return 'N/A' if text is null or empty
    }
    return text; // Otherwise, return the original text
  };

  //sorting the email sent received etc
  const mergedInteractions = Array.isArray(conversationDetails)
    ? conversationDetails
      .flatMap((conversation) => {
        const interactions = [];

        // Extract interactions with created_at timestamps
        if (conversation.email_sent) {
          interactions.push({
            ...conversation.email_sent,
            type: 'Email Sent',
            icon: 'ri-mail-open-line',
            arrow: 'ri-arrow-right-up-line',
          });
        }
        if (conversation.incoming_email) {
          interactions.push({
            ...conversation.incoming_email,
            type: 'Incoming Email',
            icon: 'ri-mail-open-line',
            arrow: 'ri-arrow-left-down-line',
          });
        }
        if (conversation.audio_call_successful) {
          interactions.push({
            ...conversation.audio_call_successful,
            type: 'Audio Call, Successful ',
            icon: 'ri-phone-line',
            arrow: 'ri-checkbox-blank-circle-fill suc-circle',
          });
        }

        if (conversation.schedule_call) {
          interactions.push({
            ...conversation.schedule_call,
            type: 'Schedule Call',
            icon: 'ri-calendar-check-line',
            arrow: '', // Changed from green circle
          });
        }

        if (conversation.schedule_chat) {
          interactions.push({
            ...conversation.schedule_chat,
            type: 'Schedule Chat',
            icon: 'ri-time-line',
            arrow: '', // Represents an upcoming chat or pending interaction
          });
        }

        if (conversation.reminder_call) {
          interactions.push({
            ...conversation.reminder_call,
            type: 'Reminder Call',
            icon: 'ri-notification-3-line',
            arrow: '', // Bell icon for reminder
          });
        }

        if (conversation.audio_call_unsuccessful) {
          interactions.push({
            ...conversation.audio_call_unsuccessful,
            type: 'Audio Call, Unsuccessful',
            icon: 'ri-phone-line',
            arrow: 'ri-checkbox-blank-circle-fill unsuc-circle',
          });
        }
        if (conversation.incoming_sms) {
          interactions.push({
            ...conversation.incoming_sms,
            type: 'Incoming SMS',
            icon: 'ri-message-2-line',
            arrow: 'ri-arrow-left-down-line',
          });
        }
        if (conversation.sent_sms) {
          interactions.push({
            ...conversation.sent_sms,
            type: 'SMS Sent',
            icon: 'ri-message-2-line',
            arrow: 'ri-arrow-right-up-line',
          });
        }
        if (conversation.video_call_successful) {
          interactions.push({
            ...conversation.video_call_successful,
            type: 'Video Call, Successful',
            icon: 'ri-video-line',
            arrow: 'ri-checkbox-blank-circle-fill suc-circle',
          });
        }
        if (conversation.video_call_unsuccessful) {
          interactions.push({
            ...conversation.video_call_unsuccessful,
            type: ' Video Call, Unsuccessful',
            icon: 'ri-video-line',
            arrow: 'ri-checkbox-blank-circle-fill unsuc-circle',
          });
        }

        return interactions;
      })
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort by created_at descending
    : [];
  // console.log('mergedInteractions:', mergedInteractions);

  if (
    !mergedInteractions.some((interaction) =>
      interaction.type.includes('Unsuccessful Call'),
    )
  ) {
    // console.log('No Unsuccessful Calls in the response');
  }

  const getResponseTitle = (raw) => {
    // Replace camelCase with space and capitalize first letter
    return raw
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camel case words
      .split(' ') // Split into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
      .join(' '); // Join the words with a space
  };

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className="d-flex gap-2 align-items-center mb-2">
            <Button
              onClick={handleNavtoTransactions}
              className="mb-0 back-arrow-btn"
            >
              <i className="fas fa-arrow-left"></i>
            </Button>

            <h3 className="bold mb-0 ml-2">
              Individual Student Report - {StudentName || 'Student Name'}
            </h3>
          </div>
          <div className="ind-teacher-report-tab">
            <Nav className="mb-0" tabs>
              {/* <NavItem>
                <NavLink
                  className={activeTab === 'all' ? 'active' : ''}
                  active={activeTab === 'all'}
                  onClick={() => toggleTab('all')}
                  style={{ cursor: 'pointer', marginRight: '2px' }}
                >
                  Student
                </NavLink>
              </NavItem> */}
              {/* <NavItem>
                <NavLink
                  className={activeTab === 'Voiceanalytics' ? 'active' : ''}
                  active={activeTab === 'Voiceanalytics'}
                  onClick={() => toggleTab('Voiceanalytics')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  Voice Analytics
                </NavLink>
              </NavItem> */}
            </Nav>
            {activeTab === 'all' && (
              <div>
                <Card className="mb-2">
                  {studentDeatils ? (
                    <CardBody>
                      {loading ? ( // Show loader while loading
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ height: '200px' }}
                        >
                          <Spinner style={{ width: '3rem', height: '3rem' }} />
                        </div>
                      ) : (
                        <Row className="g-2">
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="minty-gradient border-green mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">
                                      Last Received Email or SMS
                                    </p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">
                                      {studentDeatils?.Last_received || '0'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="sky-gradient border-sky mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">Last Spoken</p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">
                                      {studentDeatils?.Last_spoken || '0'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="peachy-gradient border-red mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">
                                      Number of 1-1 Sessions
                                    </p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">
                                      {studentDeatils?.Total_Number_of_calls ||
                                        '0'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="lavender-gradient border-lavender mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">
                                      Total 1-1 Sessions Duration (Mins)
                                    </p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">
                                      {studentDeatils?.Total_call_duration ||
                                        '0'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="minty-gradient border-green mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">
                                      Student Timezone
                                    </p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold text-break">
                                      {studentDeatils?.student_timezone || '0'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          {/*new added cards*/}
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="minty-gradient border-green mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">
                                      Number of Messages Received
                                    </p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">
                                      {cardDataTranscription?.total_recieved_messages ||
                                        '0'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="sky-gradient border-sky mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">Number of Messages Sent</p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">
                                      {cardDataTranscription?.total_sent_messages ||
                                        '0'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="peachy-gradient border-red mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">
                                      Staff Name
                                    </p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">
                                      {cardDataTranscription?.teacher ||
                                        'N/A'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="lavender-gradient border-lavender mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">
                                      Health
                                    </p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold">
                                      {studetails?.shealth ||
                                        'N/A'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Card
                              className="minty-gradient border-green mb-0 h-100 ex-link"
                              style={{ cursor: 'pointer' }}
                            >
                              <CardBody>
                                <div>
                                  <div className="mb-2">
                                    <p className="f-14 semibold">
                                      Student sentiment
                                    </p>
                                  </div>
                                  <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                    <h4 className="bold text-break">
                                      {cardDataTranscription?.student_sentiment ||
                                        'N/A'}
                                    </h4>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      )}
                    </CardBody>
                  ) : (
                    <div className="text-center p-4"></div>
                  )}
                </Card>

                <Row className="g-2 ">
                  <div>
                    <Card className="mb-2">
                      <CardBody className="">
                        <div className="interaction-history-wrapper">
                          <div className="interaction-timeline">
                            <div className="intrac-item">
                              {mergedInteractions.map((item, index) => (
                                <div key={index} className="timeline-item">
                                  <div className="timeline-line"></div>
                                  <span
                                    className={`timeline-dot ${item.type
                                      .replace(/[^a-zA-Z0-9 ]/g, '')
                                      .trim()
                                      .replace(/\s+/g, '-')
                                      .toLowerCase()}`}
                                  ></span>

                                  <div
                                    className={`timeline-icon ${getIconClass(
                                      item,
                                    )}`}
                                  >
                                    <i className={item.icon}></i>
                                  </div>
                                  <div className="timeline-content">
                                    <div className="d-flex align-items-center">
                                      <i className={item.arrow}></i>
                                      <button
                                        type="button"
                                        className="btn f-18 semibold p-0"
                                        onClick={() => {
                                          if (item.type.includes('Email')) {
                                            setSelectedEmail(item);
                                            tog_center();
                                          } else if (
                                            item.type.includes('Call') &&
                                            !item.type.includes('Video')
                                          ) {
                                            if (
                                              item.type.includes('Successful')
                                            ) {
                                              setSelectedsuccessfulcalls(item);
                                              tog_center2();
                                            } else if (
                                              item.type.includes(
                                                'Schedule Call',
                                              )
                                            ) {
                                              setseletedItem(item);
                                              setSchedulemodal_center(
                                                'Schedule Call Details',
                                              );
                                            } else if (
                                              item.type.includes('Reminder')
                                            ) {
                                              setseletedItem(item);
                                              setSchedulemodal_center(
                                                'Reminder Call Details',
                                              );
                                            }
                                          } else if (
                                            item.type.includes('Chat')
                                          ) {
                                            if (
                                              item.type.includes(
                                                'Schedule Chat',
                                              )
                                            ) {
                                              setseletedItem(item);
                                              setSchedulemodal_center(
                                                'Schedule Chat Details',
                                              );
                                            }
                                          } else if (
                                            item.type.includes('SMS')
                                          ) {
                                            setselectedsmssent(item);
                                            tog_center5();
                                          } else if (
                                            item.type.includes('Video Call')
                                          ) {
                                            if (
                                              item.type.includes('Successful')
                                            ) {
                                              setSelectedVideoCall(item);
                                              tog_centerv();
                                            }
                                          } else {
                                            console.warn(
                                              'Unhandled type:',
                                              item.type,
                                            );
                                          }
                                        }}
                                      >
                                        {item.type}
                                      </button>
                                    </div>
                                    <p className="timestamp">
                                      {item.created_at || 'Date not available'}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </Row>

                <Row className="g-2">
                  <div>
                    <Card className="mb-2">
                      <CardBody>
                        <div>
                          <div className="d-md-flex  align-items-center">
                            <div className="flex-grow-1 mb-md-0 mb-2">
                              <h5 className="f-16 bold">Insights From Last 1-1 Session</h5>
                            </div>
                          </div>

                          <h6 className="f-14 bold mt-2">Summary</h6>
                          <div
                            className="va-summary-main mt-2"
                            dangerouslySetInnerHTML={{
                              __html:
                                setStudentInsights?.summary ||
                                'No Summary Available.',
                            }}
                          ></div>
                          <h6 className="f-14 bold mt-2">Knowledge Gaps</h6>
                          <div
                            className="va-summary-main mt-2"
                            dangerouslySetInnerHTML={{
                              __html:
                                setStudentInsights?.knowledge_gaps ||
                                'No Knowledge Available.',
                            }}
                          ></div>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </Row>
                <Row className="g-2">
                  <div>
                    <Classdetails
                      conversationData={conversationData}
                      dataTabs={cardDataTranscription}
                    />
                  </div>
                </Row>
                <Row className="g-2">
                  <div>
                    <Card className="mb-2">
                      <CardBody>
                        <div>
                          <div className="d-md-flex  align-items-center">
                            <div className="flex-grow-1 mb-md-0 mb-2">
                              <h5 className="f-16 bold">History</h5>
                            </div>
                          </div>

                          <div className="mt-2">
                            <StudentTable tabledata={tabledata} />
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </Row>
                {/* <Row className="g-2"> */}
                {/* <Col md={6} className="mb-2">
                    <Card className="mb-0 h-100">
                      <CardBody>
                        <h5 className="f-16 d-flex  bold mb-3 ">
                          Number of calls flagged{' '}
                        </h5>
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={pieOptions}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md={6} className="mt-md-2 mt-0 mb-2">
                    <Card className="mb-0 h-100">
                      <CardBody>
                        <h5 className="f-16 d-flex  bold mb-3">
                          Total Messages Sent and Received
                        </h5>
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={progressOptions}
                        />
                      </CardBody>
                    </Card>
                  </Col> */}
                {/* </Row> */}
              </div>
            )}
            {/* {activeTab === "Voiceanalytics"&& (
            <div>
          <Classdetails conversationData={conversationData} dataTabs={cardDataTranscription} />
              
            </div>
            
            )} */}
            {activeTab === 'Voiceanalytics' && (
              <>
                <div>
                  <UserDetails
                    overallDataCards={cardDataTranscription}
                    loading1={loading1}
                  />
                </div>
                {/* <div>
                  <Classdetails
                    conversationData={conversationData}
                    dataTabs={cardDataTranscription}
                  />
                </div> */}
              </>
            )}
          </div>

          {/* modal */}

          {/*emailsnet*/}
          <Modal
            isOpen={modal_center}
            toggle={() => {
              tog_center();
            }}
            centered
            className="intrac-his-modal"
          >
            <div className="modal-header" style={{ height: '50px' }}>
              <h5 className="modal-title semibold mt-0">
                <Nav tabs className="nav-tabs-custom nav-justified">
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer', border: 'none' }}
                      className={classnames({
                        active: customActiveTab === '1',
                      })}
                      onClick={() => {
                        toggleCustom('1');
                      }}
                    >
                      <p className=""> Email</p>
                    </NavLink>
                  </NavItem>
                </Nav>
              </h5>
              <button
                type="button"
                onClick={() => {
                  setmodal_center(false);
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <NavItem>
                                          <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                              active: customActiveTab === "2",
                                            })}
                                            onClick={() => {
                                              toggleCustom("2");
                                            }}
                                          >
                                            <span className="">
                                              {" "}{" "}
                                              Summary
                                            </span>
                                          </NavLink>
                                        </NavItem> */}

              {/* <TabContent
                activeTab={customActiveTab}
                className="p-3 text-muted"
              >
                <TabPane tabId="1">
                  <Col sm="12"> */}
              <div className="intrac-email-wrapper">
                {selectedEmail ? (
                  <div className="email-items">
                    <div className="sen-rec-info">
                      <h6 className="sent">Sent</h6>
                      <p>{selectedEmail.created_at}</p>
                    </div>
                    <div className="email-ctn">
                      <h4>{selectedEmail.subject || 'No Subject'}</h4>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            selectedEmail?.body || 'No body content available',
                        }}
                      ></div>
                    </div>
                  </div>
                ) : (
                  <p></p>
                )}
              </div>
              {/* </Col>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    <Col sm="12">
                      <div className="intrac-email-summary-wrapper">
                        <div className="intrac-email-summary-inner">
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                conversationDetails?.recent_mails
                                  ?.sent_thread_summary ||
                                'No summary available.',
                            }}
                          ></div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent> */}
            </div>
          </Modal>
          {/*email_received*/}
          <Modal
            isOpen={modal_center1}
            toggle={() => {
              tog_center1();
            }}
            className="intrac-his-modal"
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">Email Received</h5>
              <button
                type="button"
                onClick={() => {
                  setmodal_center1(false);
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Nav tabs className="nav-tabs-custom nav-justified">
                <NavItem>
                  <NavLink
                    style={{ cursor: 'pointer' }}
                    className={classnames({
                      active: customActiveTab === '1',
                    })}
                    onClick={() => {
                      toggleCustom('1');
                    }}
                  >
                    <span className=""> Email</span>
                  </NavLink>
                </NavItem>
                {/* <NavItem>
      <NavLink
        style={{ cursor: "pointer" }}
        className={classnames({
          active: customActiveTab === "2",
        })}
        onClick={() => {
          toggleCustom("2");
        }}
      >
        <span className="">
          {" "}{" "}
          Summary
        </span>
      </NavLink>
    </NavItem> */}
              </Nav>

              <TabContent
                activeTab={customActiveTab}
                className="p-3 text-muted"
              >
                <TabPane tabId="1">
                  <Row>
                    <Col sm="12">
                      <div className="intrac-email-wrapper">
                        {/* email-1 */}
                        {selectedEmailReceived ? (
                          <div className="email-items">
                            <div className="sen-rec-info">
                              <h6 className="sent">Received</h6>
                              <p>{selectedEmailReceived?.created_at}</p>
                            </div>
                            <div className="email-ctn">
                              <h4>{selectedEmailReceived?.subject}</h4>
                              {/* <p>{selectedEmailReceived?.body}</p> */}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html:
                                    selectedEmailReceived?.body ||
                                    'No body content available',
                                }}
                              ></div>
                            </div>
                          </div>
                        ) : (
                          <p></p>
                        )}
                      </div>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    <Col sm="12">
                      <div className="intrac-email-summary-wrapper">
                        <div className="intrac-email-summary-inner">
                          {/* <h4>Assignment 3: Network Security</h4> */}
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                conversationDetails?.recent_mails
                                  ?.received_thread_summary ||
                                'No summary available.',
                            }}
                          ></div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </div>
          </Modal>

          {/*successsul modal */}

          <Modal
            isOpen={modal_center2}
            toggle={() => {
              tog_center2();
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">Audio Call, Succesful</h5>
              <button
                type="button"
                onClick={() => {
                  setmodal_center2(false);
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {selectedsuccessfulcalls ? (
              <div className="modal-body">
                <p>{selectedsuccessfulcalls?.created_at}</p>
                <br></br>
                {
                  selectedsuccessfulcalls.recording_url ?
                    <audio controls controlsList="nodownload">
                      <source
                        src={selectedsuccessfulcalls.recording_url}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio> :
                    <p>Session recording not available </p>

                }
              </div>
            ) : (
              <p></p>
            )}
          </Modal>
          {/*Schdule modal */}
          <Modal
            isOpen={Schedulemodal_center}
            toggle={() => setSchedulemodal_center(false)}
            centered
          >
            <div className="modal-header text-white py-3">
              <h5 className="modal-title m-0 d-flex align-items-center">
                {Schedulemodal_center}
              </h5>
              <button
                type="button"
                className="btn-close "
                aria-label="Close"
                onClick={() => setSchedulemodal_center(false)}
              ></button>
            </div>

            {seletedItem ? (
              <div className="modal-body p-4">
                <div className="mb-4">
                  <label className="fw-semibold text-dark">Summary</label>
                  <p className="text-muted mb-0">{seletedItem.summary}</p>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <label className="fw-semibold text-dark">Start Time</label>
                    <p className="text-muted mb-0">
                      {new Date(seletedItem.start).toLocaleString()}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <label className="fw-semibold text-dark">End Time</label>
                    <p className="text-muted mb-0">
                      {new Date(seletedItem.end).toLocaleString()}
                    </p>
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <label className="fw-semibold text-dark">Response</label>
                    <p className="mb-0">
                      <span
                        className={`badge p-2`}
                        style={{
                          color: '#303030',
                          backgroundColor:
                            seletedItem.response === 'notResponded'
                              ? '#9E9E9E'
                              : seletedItem.response === 'declined'
                                ? '#ff9a93'
                                : seletedItem.response === 'tentative'
                                  ? '#ffde7b'
                                  : seletedItem.response === 'accepted'
                                    ? '#6fff74'
                                    : seletedItem.response === 'needsAction'
                                      ? '#7bc4ff'
                                      : '#d781ff',
                        }}
                      >
                        {getResponseTitle(seletedItem.response)}
                      </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <label className="fw-semibold text-dark">Type</label>
                    <p className="text-muted mb-0">{seletedItem.type}</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="modal-body p-5 text-center text-muted">
                <p className="lead mb-0">
                  No call details selected. Please choose an item to view its
                  details.
                </p>
              </div>
            )}
          </Modal>

          {/*unsuccessful modal */}

          <Modal
            isOpen={modal_center3}
            toggle={() => {
              tog_center3();
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">Unsuccesful Call</h5>
              <button
                type="button"
                onClick={() => {
                  setmodal_center3(false);
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {selectedUnsuccessfulcalls ? (
              <div className="modal-body">
                <p>{selectedUnsuccessfulcalls?.created_at}</p>
                <br></br>
                {
                  selectedUnsuccessfulcalls.recording_url ?
                    <audio controls controlsList="nodownload">
                      <source
                        src={selectedUnsuccessfulcalls.recording_url}
                        type="audio/mpeg"
                      />
                      Your browser does not support the audio element.
                    </audio> :
                    <p>Session recording not available </p>
                }
              </div>
            ) : (
              <p></p>
            )}
          </Modal>
          {/* incoming sms modal */}

          <Modal
            isOpen={modal_center4}
            toggle={() => {
              tog_center4();
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">Incoming SMS</h5>
              <button
                type="button"
                onClick={() => {
                  setmodal_center4(false);
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {selectedIncomingsms ? (
              <div className="modal-body">
                <p>{selectedIncomingsms.created_at}</p>
                <br></br>
                <p>{selectedIncomingsms.message}</p>
              </div>
            ) : (
              <p></p>
            )}
          </Modal>
          {/*sms sent mpdal */}

          <Modal
            isOpen={modal_center5}
            toggle={() => {
              tog_center5();
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">SMS Sent</h5>
              <button
                type="button"
                onClick={() => {
                  setmodal_center5(false);
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {selectedsmssent ? (
              <div className="modal-body">
                <p>{selectedsmssent.created_at}</p>
                <br></br>
                <p>{selectedsmssent.message}</p>
              </div>
            ) : (
              <p></p>
            )}
          </Modal>
          {/*successsul modal */}
          {/*videocall modal */}

          <Modal isOpen={modal_centerv} toggle={tog_centerv} centered>
            <div className="modal-header">
              <h5 className="modal-title mt-0"> Video Call, Successful</h5>
              <button
                type="button"
                onClick={() => setmodal_centerv(false)}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              {selectedVideoCall ? (
                <>
                  <p>{selectedVideoCall?.created_at}</p>
                  <br />
                  {selectedVideoCall.recording_url ? (
                    <video controls width="100%" controlsList="nodownload">
                      <source
                        src={selectedVideoCall.recording_url}
                        type="video/mp4"
                      />
                      Your browser does not support the video element.
                    </video>
                  ) : (
                    <p>Session recording not available </p>
                  )}
                </>
              ) : (
                <p className="text-muted">No video selected</p>
              )}
            </div>
          </Modal>

          <Modal
            isOpen={modal_video_unsuccess}
            toggle={() => setModalVideoUnsuccess(false)}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">Unsuccessful Video Call</h5>
              <button
                type="button"
                onClick={() => setModalVideoUnsuccess(false)}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              {selectedUnsuccessfulVideoCall ? (
                <>
                  <p>{selectedUnsuccessfulVideoCall?.created_at}</p>
                  <br />
                  {selectedUnsuccessfulVideoCall.recording_url ? (
                    <video controls width="100%" controlsList="nodownload">
                      <source
                        src={selectedUnsuccessfulVideoCall.recording_url}
                        type="video/mp4"
                      />
                      Your browser does not support the video element.
                    </video>
                  ) : (
                    <p>Session recording not available </p>
                  )}
                </>
              ) : (
                <p className="text-muted">No video selected</p>
              )}
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Inbox;
